import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

export default function SessionsLayout() {
  const location = useLocation();
  const isOnboarding = location.pathname && location.pathname.startsWith("/sessions/onboarding");

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: isOnboarding ? "visible" : "hidden",
        backgroundColor: isOnboarding ? "transparent" : "#707070",
      }}
    >
      {/* ── Static background — never animates (hidden for onboarding) ── */}
      {!isOnboarding && (
        <>
          <video
            autoPlay
            muted
            loop
            playsInline
            src="/assets/videoLogin/login_partie_client(1).mp4"
            style={{
              position: "fixed",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
            }}
          />
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "linear-gradient(to right, rgba(0,0,0,0.85) 0%, rgba(44,44,44,0.55) 100%)",
              zIndex: 1,
            }}
          />
        </>
      )}

      {/* ── Child rendering. Onboarding should take the full page (no centering wrapper) ── */}
      {isOnboarding ? (
        <Outlet />
      ) : (
        <div
          className="auth-shell"
          style={{
            position: "relative",
            zIndex: 2,
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
          }}
        >
          <AnimatePresence mode="wait">
            <Outlet key={location.pathname} />
          </AnimatePresence>
        </div>
      )}

      <style>{`
        /* Flat 16px padding read as "no margin" on laptop-width screens once
           the card nears its 800px max-width. Give wider viewports real
           breathing room, but keep exactly 16px at <=480px — the mobile
           auth-card rules cancel this padding with a hardcoded -16px
           margin for the edge-to-edge treatment, so it must stay in sync. */
        .auth-shell {
          padding: clamp(24px, 4vw, 64px);
        }
        @media (max-width: 480px) {
          .auth-shell { padding: 16px; }
        }
      `}</style>
    </div>
  );
}